import React, { useState } from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { IconButton } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { useTranslation } from "react-i18next";
import EditArrayVariableEditor from "./EditArrayVariableEditor";

function ArrayVariableEditor({ data, setData, titles, header }) {
  const [index, setIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  function handleOpenEdit(indx, setState) {
    setIndex(indx);
    setState(true);
  }
  return (
    <>
      <div className="form-element">
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "1%",backgroundColor: "#eee" ,padding:"5px"}}>{t("ARRAY-VARIABLE-EDITOR.INDEX")}</th>
              <th style={{ backgroundColor: "#eee" }}>
                {titles.length > 0
                  ? t("ARRAY-VARIABLE-EDITOR." + titles[0])
                  : t("ARRAY-VARIABLE-EDITOR.VALUE")}
              </th>
              <th style={{ width: "1%"  }}>
              <IconButton
                  style={{ padding: 0, float: "right" }}
                  onClick={() => setOpen(true)}
                >
                  <AddCircleOutlineIcon
                    style={{ color: "#8C90A2" }}
                  />
                </IconButton>
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) &&
              data.map((item, indx) => (
                <tr key={indx}>
                  <td>{indx+1}</td>
                  <td>{item}</td>
                  <td onClick={() => handleOpenEdit(indx, setOpen)}>
                    <EditOutlinedIcon />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {open && (
        <EditArrayVariableEditor
          array={data}
          setArray={setData}
          index={index}
          setIndex={setIndex}
          setOpen={setOpen}
          titles={titles}
          header={header}
        />
      )}
    </>
  );
}

export default ArrayVariableEditor;
